<template>
  <section id="manage-workspace" class="card my-2 p-2">
    <div>
      <div v-if="resultbuyingdomain != 'DONE'">

        <div class="card p-2 mt-3">
          <div class="">
            <button @click="getDomainsFree()" :disabled="domaincom.length == 0 || buying"
              :class="loadingtotal  ? 'btn btn-sm btn-loading' : 'btn btn-sm btn-primary'">See available domains</button>
            <span v-if="total != null" class="ml-2 badge badge-danger">Total available domains: {{ total }}</span>
            <span v-else class="loadingres spinner-border loading-spinner ml-2"></span>
          </div>
          <li v-for="(d, index) in domainsfree" :key="index" class="my-2">{{ d.domain }} | {{ d.created }} | {{ d.workspace_id }} 
            <!-- d.dns[0] estaba dentro como un v if en el icono, no se bien la funcion que cumplia -->
            <i class="icon-checkmark text-success mx-2"></i> <button :disabled="d.workspace_id != zapmail_id"
              :class="buying ? 'btn btn-sm btn-loading' : 'btn btn-sm btn-primary'" @click="reUseDoman(d.domain)">Re-use this domain <span v-if="d.workspace_id != zapmail_id" class="badge badge-danger mr-2">available in another workspace</span> </button></li>
        </div>

        <input @input="recalculate()" v-model="domainname" class="mr-1 my-1" />
        <!-- cuando se necesite la compra de dominios automatica cambiarle el parametro a buydomain con '0' -->
        <button @click="buyDomain()" :disabled="domaincom.length == 0 || buying" class="btn btn-sm btn-success mx-2">Buy
          {{ domaincom }}(-pro).com </button>
      </div>
    </div>
    <span v-if="buying">
      <span class="loadingres spinner-border loading-spinner ml-2"></span> buying...{{ domain_purchase }}
    </span>
    <!-- <span class="badge badge-danger" v-if="resultbuyingdomain == 'Unavailable'">{{resultbuyingdomain}}</span> -->
    <span class="badge badge-success" v-if="resultbuyingdomain == 'DONE'">{{ resultbuyingdomain }}
      {{ domain_purchase }}</span>
    <div v-if="resultbuyingdomain != 'DONE'">
      Options: <div class="row">
        <small class="col-sm-6 col-md-4 col-lg-3" v-for="(pref, i) in prefix.split(',')" :key="i">
          {{ pref }}{{ domaincom }}.com
          <span class="badge badge-danger ml-2" v-if="domainStatus[i] == 'Unavailable'">{{ domainStatus[i] }}</span>
        </small>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { workspaceService } from "@/_services";

export default {
  props: {
    domain: "",
    prefix: "",
    project: false,
    zapmail_id: "",
  },
  data() {
    return {
      loading: false,
      domainsfree: [],
      buying: false,
      domaincom: false,
      domaintobuy: [],
      domainname: "",
      buyingdomain: "",
      resultbuyingdomain: "",
      domain_purchase: "",
      indexBuy: 0,
      domainStatus: [], // Array para rastrear el estado de cada dominio
      total: null,
      loadingtotal: false,
    };
  },

  created() {
    this.loading = true;
    this.domainname = this.domain.name;
    this.recalculate();
    this.initializeDomainStatus();
    // getTotalDomainsFree se ejecutará cuando se abra el fieldset
  },
  methods: {
    initializeDomainStatus() {
      // Inicializar el array de estados con el mismo tamaño que los prefijos
      if (this.prefix) {
        const prefixCount = this.prefix.split(',').length;
        this.domainStatus = new Array(prefixCount).fill('');
      }
    },
    recalculate() {
      let domainne;
      domainne = this.getDomainProcessed(this.domainname);
      this.domaincom = domainne;
      // Reinicializar el estado cuando cambia el dominio
      this.initializeDomainStatus();
    },

    getDomainsFree() {
      this.loadingtotal = true;
      workspaceService
        .getFreeZapmailDomainsByClient(this.domain.client_id)
        .then((result) => {
          console.log(result);
          this.domainsfree = result;
          this.loadingtotal = false;
        });
    },

    getTotalDomainsFree() {
      // Solo cargar si no se ha cargado ya
      if (this.total === null && !this.loadingtotal) {
        this.loadingtotal = true;
        workspaceService
          .getFreeZapmailDomainsByClient(this.domain.client_id, false, true)
          .then((result) => {
            console.log(result);
            this.total = result.count;
            console.log(this.total);
            this.loadingtotal = false;
          })
          .catch((error) => {
            this.loadingtotal = false;
            console.error("Error loading total domains:", error);
          });
      }
    },

    reUseDoman(domainuse) {
      this.buying = true;
      workspaceService
        .zapmailReUseDomain(domainuse, this.domain, this.zapmail_id)
        .then((result) => {
          this.resultbuyingdomain = "DONE";
          this.buying = false;
        });
    },

    buyNow() {
      this.buying = true;
      this.executeSequentially(0);
    },

    buyDomain() {
      this.buying = true;
      let prefixword = this.prefix.split(",");

      // Verificar si ya se procesaron todos los prefijos
      if (this.indexBuy >= prefixword.length) {
        this.buying = false;
        return;
      }

      // Seleccionar los siguientes 20 dominios desde indexBuy
      const domainsToBuy = [];
      const startIndex = this.indexBuy;
      const endIndex = Math.min(startIndex + 20, prefixword.length);

      for (let i = startIndex; i < endIndex; i++) {
        const item = prefixword[i];
        let domain;
        if (item != undefined && item.trim() !== "") {
          domain = item + this.domaincom + ".com";
        } else {
          domain = this.domaincom + ".com";
        }
        domainsToBuy.push(domain);
      }

      // Actualizar indexBuy para la próxima vez
      this.indexBuy = endIndex;

      this.resultbuyingdomain = "";

      workspaceService
        .buyNowZapmail(domainsToBuy, this.domain, this.zapmail_id)
        .then((result) => {
          // Marcar los dominios como Unavailable después de la respuesta de la API (ok o no ok)
          for (let i = startIndex; i < endIndex; i++) {
            this.$set(this.domainStatus, i, "Unavailable");
          }

          if (result.status && result.status == "ok") {
            this.resultbuyingdomain = "DONE";
            this.domain_purchase = result.domain_purchased;
            this.buying = false;
            return;
          } else {
            this.resultbuyingdomain = "Unavailable";
            this.buying = false;
          }
        })
        .catch((error) => {
          for (let i = startIndex; i < endIndex; i++) {
            this.$set(this.domainStatus, i, "Unavailable");
          }
          this.$swal({
            type: "error",
            title: this.$t("lang.label.error"),
            text: error,
            showConfirmButton: true,
          });
          this.buying = false;
        });
    },

    //  METODO PARA CUANDO ZAPMAIL ESTE TESTEADO Y SE DESEE QUE EL CAMBIO DE DOMINIOS SEA AUTOMATICO
    // buyDomain(index){
    //   this.buying = true;
    //   let prefixword = this.prefix.split(",");

    //   if (this.indexBuy >= prefixword.length) {
    //     // No se encontró el resultado deseado
    //     this.buying = false;
    //     return;
    //   }

    //   const item = prefixword[index];
    //   if(item != undefined){
    //     this.buyingdomain = item + this.domaincom + ".com";
    //   }else{
    //     this.buyingdomain = this.domaincom + ".com";
    //   }
    //   this.resultbuyingdomain = "";
    //   workspaceService
    //   .buyNowZapmail(this.buyingdomain, this.domain, this.zapmail_id)
    //   .then((result) => {
    //     if (result == "ok") {
    //       this.resultbuyingdomain = "DONE";
    //       this.buying = false;
    //       index + 1;
    //       return;
    //     } else {
    //       this.resultbuyingdomain = "Unavailable";
    //       this.buying = false;
    //       this.buyDomain(index + 1);
    //     }
    //   })
    //   .catch((error) => {
    //     this.$swal({
    //       type: "error",
    //       title: this.$t("lang.label.error"),
    //       text: error,
    //       showConfirmButton: true,
    //     });
    //   });
    // },

    executeSequentially(index) {
      let prefixword = this.prefix.split(",");

      if (index >= prefixword.length) {
        // No se encontró el resultado deseado
        this.buying = false;
        return;
      }

      const item = prefixword[index];

      this.buyingdomain = item + this.domaincom + ".com";
      this.resultbuyingdomain = "";
      workspaceService
        .buyNow(this.buyingdomain, this.domain, this.project)
        .then(
          (result) => {
            if (result == "ok") {
              // Se encontró el resultado deseado
              this.resultbuyingdomain = "DONE";
              this.buying = false;
              return;
            } else {
              this.resultbuyingdomain = "Unavailable";

              // Sigue con la ejecución secuencial
              this.executeSequentially(index + 1);
            }
          },
          (error) => {
            this.$swal({
              type: "error",
              title: this.$t("lang.label.error"),
              text: error,
              showConfirmButton: true,
            });
          }
        );
    },

    getDomainProcessed(domain) {
      domain = domain.replace(/\s/g, "");
      let reemplazos = {
        à: "a",
        á: "a",
        â: "a",
        ç: "c",
        é: "e",
        è: "e",
        ê: "e",
        ë: "e",
        î: "i",
        ï: "i",
        ô: "o",
        ù: "u",
        û: "u",
        ü: "u",
      };
      Object.entries(reemplazos).forEach(([caracter, reemplazo]) => {
        const regex = new RegExp(caracter, "g");
        domain = domain.replace(regex, reemplazo);
      });

      domain = domain.toLowerCase();

      return domain;
    },
  },
};
</script>